import React from "react";
import "./styles/About.css";
import { FiTarget, FiEye, FiUser } from "react-icons/fi";

const galleryImages = [
  { src: "/images/welding.jpeg", alt: "Fabrication & Welding" },
  { src: "/images/painting.jpeg", alt: "Industrial Painting" },
  { src: "/images/assembly.jpeg", alt: "Mechanical Assembly" },
  { src: "/images/blasting.jpeg", alt: "Shot Blasting" },
  { src: "/images/irrigation.jpeg", alt: "Erection Work" },
  { src: "/images/metalizing.jpeg", alt: "Metalizing Work" }
];

export default function About() {
  return (
    <div className="about-page container py-5">
      {/* About Heading */}
      <section className="mb-5 text-center">
        <h2 className="about-heading">About Reena Industries</h2>
        <div className="about-separator"></div>
        <p className="about-description">
          Reena Industries is a leading manufacturer specializing in the production of precision components and providing innovative manufacturing solutions for a variety of industries. With years of experience and a commitment to excellence, we have established ourselves as a trusted partner for businesses looking for high-quality, reliable products that meet the most stringent industry standards.
        </p>
      </section>

      {/* Director's Desk */}
      <section className="director-section p-4 p-md-5 mb-5 shadow">
        <div className="row align-items-center">
          <div className="col-md-4 text-center mb-4 mb-md-0">
            <div className="director-avatar">
              <div className="avatar-icon">
                <FiUser />
              </div>
              <div className="avatar-role">DIRECTOR</div>
            </div>
          </div>
          <div className="col-md-8">
            <h3 className="director-title mb-4">From the Director's Desk</h3>
            <div className="director-details">
              <div className="detail-item">
                <span className="detail-label">Name</span>
                <span className="detail-value">Mr. Abhay Prajapati</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Experience</span>
                <span className="detail-value">20+ years in the manufacturing industry</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Expertise</span>
                <span className="detail-value">Engineering Design, Production Management</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Founded</span>
                <span className="detail-value">Reena Industries in 2021 with the vision to bring quality and innovation together.</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Meet Our Team */}
      <section className="team-section-container mb-5">
        <h3 className="text-center section-subheading mb-4">Meet Our Team</h3>
        <div className="row g-4 justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="team-card p-4 shadow h-100">
              <div className="d-flex align-items-center mb-3">
                <div className="team-avatar">PP</div>
                <div className="ms-3">
                  <h5 className="team-name mb-0">Pradeep Prajapati</h5>
                  <span className="team-position text-accent">Chief Engineer</span>
                </div>
              </div>
              <p className="team-description mb-0">
                <strong>Role:</strong> Oversees design and production operations.
              </p>
            </div>
          </div>
          <div className="col-md-6 col-lg-5">
            <div className="team-card p-4 shadow h-100">
              <div className="d-flex align-items-center mb-3">
                <div className="team-avatar">AP</div>
                <div className="ms-3">
                  <h5 className="team-name mb-0">Anshu Prajapati</h5>
                  <span className="team-position text-accent">Operations Manager</span>
                </div>
              </div>
              <p className="team-description mb-0">
                <strong>Role:</strong> Manages logistics and quality assurance.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery */}
      <section className="gallery-section-container mb-5">
        <h3 className="text-center section-subheading mb-4">Gallery</h3>
        <div className="row g-3">
          {galleryImages.map((image, idx) => (
            <div key={idx} className="col-6 col-md-4">
              <div className="gallery-card">
                <img src={image.src} alt={image.alt} className="img-fluid" />
                <div className="gallery-hover">
                  <span className="gallery-text">{image.alt}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Mission and Vision */}
      <section className="row mission-vision-section g-4 text-center">
        <div className="col-md-6">
          <div className="card h-100 p-4 p-md-5 shadow mission-card">
            <div className="card-icon">
              <FiTarget />
            </div>
            <h4 className="card-title">Our Mission</h4>
            <div className="card-separator"></div>
            <p className="card-text">
              To innovate and deliver engineering excellence in manufacturing
              with a commitment to quality and integrity.
            </p>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card h-100 p-4 p-md-5 shadow vision-card">
            <div className="card-icon">
              <FiEye />
            </div>
            <h4 className="card-title">Our Vision</h4>
            <div className="card-separator"></div>
            <p className="card-text">
              To be a global leader in manufacturing, empowering industries with
              reliable and advanced solutions.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
